import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "exit",
    description: "Exits terminal",
    options: [],
    arguments: [],
    callback: (_writer, optsAndArgs) => {
        optsAndArgs._exitCallback();
        return {};
    }
} as ICLICommand;
